import permisos, { RESOURCE_IMPORTACIONES } from '@/auth/permissions/modules/importacionesPg'
import {
    ROUTE_DERECHO_ARANCELARIOS,
    ROUTE_INFORME_REQUERIMIENTO_IMPORTACIONES,
    ROUTE_RESUMEN_LIQUIDACIONES_GASTOS,
} from '@/router/routes/importaciones-pg/nombres/informes'
import { defineMenu } from '@/utils/menu'

const { informes } = permisos
export default defineMenu([
    {
        title: 'importaciones.subopciones.recepcion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: informes.requerimientoImportaciones,
        route: ROUTE_INFORME_REQUERIMIENTO_IMPORTACIONES,
    },
    {
        title: 'importaciones.subopciones.resumen_liquidaciones_gastos',
        resource: RESOURCE_IMPORTACIONES,
        action: informes.resumenLiquidacionesGastos,
        route: ROUTE_RESUMEN_LIQUIDACIONES_GASTOS,
    },
    {
        title: 'importaciones.subopciones.derechos_arancelarios',
        resource: RESOURCE_IMPORTACIONES,
        action: informes.derechoArancelarios,
        route: ROUTE_DERECHO_ARANCELARIOS,
    },
])
